import { ASSET_IMAGES } from "./constants/paths";

const DEFAULT_AUTH_LOGO = `${ASSET_IMAGES}/logos/xpit_logo_full.png`;
const DEFAULT_FAVICON = `${ASSET_IMAGES}/logos/favicon.ico`;
const ARKITRACKING_AUTH_LOGO =
  process.env.REACT_APP_ARKITRACKING_AUTH_LOGO_URL || DEFAULT_AUTH_LOGO;
const ARKITRACKING_FAVICON =
  process.env.REACT_APP_ARKITRACKING_FAVICON_URL || DEFAULT_FAVICON;

const TENANT_BRANDING_BY_HOST = {
  "connect.xpit.cl": {
    key: "xpit",
    displayName: "Xpit Connect",
    authLogoUrl: DEFAULT_AUTH_LOGO,
    faviconUrl: DEFAULT_FAVICON,
  },
  "arkitracking.xpit.cl": {
    key: "arkitracking",
    displayName: "Arkitracking",
    authLogoUrl: ARKITRACKING_AUTH_LOGO,
    faviconUrl: ARKITRACKING_FAVICON,
  },
};

const DEFAULT_BRANDING = {
  key: "default",
  displayName: "Xpit Connect",
  authLogoUrl: DEFAULT_AUTH_LOGO,
  faviconUrl: DEFAULT_FAVICON,
};

const normalizeHost = (hostname = "") => hostname.toLowerCase().trim().split(":")[0];

export const getTenantBranding = (hostname) => {
  const host = normalizeHost(hostname || (typeof window !== "undefined" ? window.location.hostname : ""));
  return TENANT_BRANDING_BY_HOST[host] || DEFAULT_BRANDING;
};

const setMetaContent = (selector, content) => {
  const element = document.querySelector(selector);
  if (element) {
    element.setAttribute("content", content);
  }
};

const setIconHref = (selector, href) => {
  const element = document.querySelector(selector);
  if (element) {
    element.setAttribute("href", href);
  }
};

export const applyTenantBrandingToDocument = (hostname) => {
  if (typeof document === "undefined") {
    return;
  }

  const tenantBranding = getTenantBranding(hostname);

  document.title = tenantBranding.displayName;
  setIconHref("link[rel='icon']", tenantBranding.faviconUrl);
  setIconHref("link[rel='shortcut icon']", tenantBranding.faviconUrl);
  setIconHref("link[rel='apple-touch-icon']", tenantBranding.faviconUrl);
  setMetaContent("meta[name='application-name']", tenantBranding.displayName);
  setMetaContent("meta[property='og:site_name']", tenantBranding.displayName);
  setMetaContent("meta[property='og:title']", tenantBranding.displayName);
  setMetaContent("meta[name='twitter:title']", tenantBranding.displayName);
};
